import { launch0Stats } from '@/mocks/home';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function LaunchZero() {
  return (
    <section id="launch0" className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            title="从 0# 开始验证"
            en="Data Validation"
            subtitle="帝星咖啡：从一家消费场景，升级为九畴云铺的 0# 数商综合体验证场——背后连接京客隆百店、千县万村供应链和数字消费通道。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* 图片 */}
          <Reveal delay={100}>
            <div className="relative rounded-lg overflow-hidden border border-foreground-700">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20commerce%20cafe%20experience%20space%20with%20smart%20digital%20shelf%20screens%20and%20warm%20wooden%20interior%2C%20people%20using%20mobile%20app%20for%20digital%20consumption%2C%20clean%20minimal%20aesthetic%2C%20deep%20blue%20and%20green%20accent%20lighting%2C%20editorial%20photography%20soft%20shadows&width=1200&height=800&seq=dx-coffee-01&orientation=landscape"
                alt="帝星数商综合体 0# 验证场景"
                title="九畴云铺 0# 帝星数商综合体"
                className="w-full h-full object-cover object-top aspect-[4/3]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="text-sm font-medium text-background-50">帝星数商综合体</div>
                <div className="text-xs text-background-200">万村万店振兴乡村 · 0 号数商综合体</div>
              </div>
            </div>
          </Reveal>

          {/* 大数字 */}
          <Reveal delay={150}>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {launch0Stats.map((s) => (
                <div
                  key={s.label}
                  className="p-5 rounded-lg bg-foreground-900 border border-foreground-700"
                >
                  <div className="font-heading font-bold text-2xl md:text-3xl text-accent-400">
                    {s.value}
                  </div>
                  <div className="mt-2 text-xs text-foreground-400 leading-snug">{s.label}</div>
                </div>
              ))}
            </div>
            <p className="mt-6 text-xs text-foreground-500 leading-relaxed">
              以上数据来自九畴云市首发项目清单，属于项目规划与首发目标，实际以项目运营数据为准。
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}